import { render, staticRenderFns } from "./create-work-order-form.html?vue&type=template&id=b977d8e6&scoped=true&"
import script from "./create-work-order-form.ts?vue&type=script&lang=js&"
export * from "./create-work-order-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b977d8e6",
  null
  
)

export default component.exports